import { PropsWithChildren } from 'react';

import { AuthProvider } from './AuthProvider';
import { CacheProvider } from './cache/CacheProvider';
import { FundraiserPageProvider } from './FundraiserPageProvider';
import { MessageProvider } from './MessageProvider';
import { MessagingStateProvider } from './MessagingStateProvider';
import { NotificationProvider } from './NotificationProvider';
import { PopupManagerProvider } from './PopupManagerProvider';
import { ShippingAddressAlerts, ShippingAddressProvider } from './ShippingAddressProvider';

const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <AuthProvider>
      <MessagingStateProvider>
        <CacheProvider>
          <FundraiserPageProvider>
            <NotificationProvider>
              <ShippingAddressProvider>
                <PopupManagerProvider>
                  <ShippingAddressAlerts />
                  <MessageProvider>{children}</MessageProvider>
                </PopupManagerProvider>
              </ShippingAddressProvider>
            </NotificationProvider>
          </FundraiserPageProvider>
        </CacheProvider>
      </MessagingStateProvider>
    </AuthProvider>
  );
};

export default AppProviders;
